import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h2>Error 404: Page Not Found</h2>
            <p>The project you are looking for doesn't exist or has been moved.</p>
        </div>
    );
};

export default NotFound;